// Rascunho local (IndexedDB) do formulário "Dados Iniciais RSVP".
//
// Um único object store 'evento_rsvp', com keyPath [evento, campo]:
//   - { evento, campo: '__campos', valor }  -> UMA entrada com os campos de texto/seleção/hotéis +
//                                              estados auxiliares (sem anexos). Barata de reescrever.
//   - { evento, campo: 'fileplanilha', valor: File }  -> UM registro POR ANEXO. Anexar/trocar um
//                                              arquivo grava só aquele registro; digitar texto nunca
//                                              reescreve blob nenhum.
// Um índice por 'evento' permite trazer todos os registros do evento de uma vez.
// rascunhoRsvp(eventoId) devolve um acessor ligado ao evento. Tudo best-effort: falha de storage
// é engolida para nunca quebrar a tela.

const DB_NAME = 'accessRascunhos';
const DB_VERSION = 1;
const STORE = 'evento_rsvp';
const INDEX_EVENTO = 'porEvento';
const CAMPO_TEXTO = '__campos';

function abrirDb() {
    return new Promise((resolve, reject) => {
        if (typeof window === 'undefined' || !window.indexedDB) {
            reject(new Error('IndexedDB indisponível'));
            return;
        }
        const req = window.indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
            const db = req.result;
            if (!db.objectStoreNames.contains(STORE)) {
                const os = db.createObjectStore(STORE, { keyPath: ['evento', 'campo'] });
                os.createIndex(INDEX_EVENTO, 'evento', { unique: false });
            }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
}

async function put(evento, campo, valor) {
    try {
        const db = await abrirDb();
        await new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, 'readwrite');
            tx.objectStore(STORE).put({ evento, campo, valor });
            tx.oncomplete = () => resolve();
            tx.onerror = () => reject(tx.error);
            tx.onabort = () => reject(tx.error);
        });
        db.close();
    } catch (e) {
        console.warn('rascunhoRsvp.put falhou:', e);
    }
}

async function del(evento, campo) {
    try {
        const db = await abrirDb();
        await new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, 'readwrite');
            tx.objectStore(STORE).delete([evento, campo]);
            tx.oncomplete = () => resolve();
            tx.onerror = () => reject(tx.error);
            tx.onabort = () => reject(tx.error);
        });
        db.close();
    } catch (e) {
        console.warn('rascunhoRsvp.del falhou:', e);
    }
}

async function carregarCampos(evento) {
    try {
        const db = await abrirDb();
        const registro = await new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, 'readonly');
            const req = tx.objectStore(STORE).get([evento, CAMPO_TEXTO]);
            req.onsuccess = () => resolve(req.result);
            req.onerror = () => reject(req.error);
        });
        db.close();
        return registro ? registro.valor : null;
    } catch (e) {
        console.warn('rascunhoRsvp.carregarCampos falhou:', e);
        return null;
    }
}

async function carregarArquivos(evento) {
    try {
        const db = await abrirDb();
        const registros = await new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, 'readonly');
            const req = tx.objectStore(STORE).index(INDEX_EVENTO).getAll(evento);
            req.onsuccess = () => resolve(req.result || []);
            req.onerror = () => reject(req.error);
        });
        db.close();
        return registros
            .filter((r) => r.campo !== CAMPO_TEXTO)
            .reduce((acc, r) => { acc[r.campo] = r.valor; return acc; }, {});
    } catch (e) {
        console.warn('rascunhoRsvp.carregarArquivos falhou:', e);
        return {};
    }
}

async function limpar(evento) {
    try {
        const db = await abrirDb();
        await new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, 'readwrite');
            const os = tx.objectStore(STORE);
            const req = os.index(INDEX_EVENTO).getAllKeys(evento);
            req.onsuccess = () => { (req.result || []).forEach((pk) => os.delete(pk)); };
            req.onerror = () => reject(req.error);
            tx.oncomplete = () => resolve();
            tx.onerror = () => reject(tx.error);
            tx.onabort = () => reject(tx.error);
        });
        db.close();
    } catch (e) {
        console.warn('rascunhoRsvp.limpar falhou:', e);
    }
}

export function rascunhoRsvp(eventoId) {
    const evento = String(eventoId);
    return {
        salvarCampos: (campos) => put(evento, CAMPO_TEXTO, campos),
        carregarCampos: () => carregarCampos(evento),
        salvarArquivo: (campo, arquivo) => put(evento, campo, arquivo),
        carregarArquivos: () => carregarArquivos(evento),
        removerArquivo: (campo) => del(evento, campo),
        limpar: () => limpar(evento),
    };
}
